export default {
      id: "save-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "assets/webdesktop/web-desktop-sprite.svg#save",
      toString: function () {
        return this.url;
      }
    }